import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";

export type SirenDefaultDeliveryMethods = {
    id: string;
    clientID?: string;
    departmentID?: string;
    deliveryMethods: string[];
    updatedBy: string;
    updatedAt: string;
    clientName: string;
    departmentName: string;
};

export async function getSirenDefaultDeliveryMethods(page: number, limit: number, clientID?: string): Promise<PaginatedResponseV2<SirenDefaultDeliveryMethods> | null> {
    try {
        const params: Record<string, string | number> = {page, limit};
        if (clientID) params.clientID = clientID;
        const res = await platformAPI.get<PaginatedResponseV2<SirenDefaultDeliveryMethods>>("api/siren/default-delivery-methods", {params});
        return res.data;
    } catch {
        return null;
    }
}

export async function resolveSirenDefaultDeliveryMethods(clientID?: string, departmentID?: string): Promise<SirenDefaultDeliveryMethods | null> {
    try {
        const params: Record<string, string> = {};
        if (clientID) params.clientID = clientID;
        if (departmentID) params.departmentID = departmentID;
        const res = await platformAPI.get<SirenDefaultDeliveryMethods>("api/siren/default-delivery-methods/resolve", {params});
        return res.data;
    } catch {
        return null;
    }
}
